import GHParam from './GHParam';

export default class GHInputParam extends GHParam {
  constructor (name, nickName, sourceGuid, scriptParamAccess, typeHintId, defaultValue) {
    super(name, nickName);

    this.sourceGuid = sourceGuid;
    this.scriptParamAccess = scriptParamAccess;
    this.typeHintId = typeHintId;
    this.defaultValue = defaultValue;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/GHInputParam.js